import React from "react";
import IconPreview from "../BuilderComponents/Preview/IconPreview";
import { parseCustomCss } from "../../Pages/FlexibleLayout/utils";
const ButtonPreview = ({ config, classes }) => {
  const customStyles = config?.custom_css ? parseCustomCss(config.custom_css) : {};
  return (
    <button className={`z-btn no_wrap ${classes}`} style={customStyles}>
      {config?.icon && <IconPreview icon={config.icon || ""} />}
      {config.name}
    </button>
  );
};

export default ButtonPreview;
